import { render, staticRenderFns } from "./storageFee.vue?vue&type=template&id=52ac3821&scoped=true&"
import script from "./storageFee.vue?vue&type=script&lang=js&"
export * from "./storageFee.vue?vue&type=script&lang=js&"
import style0 from "./storageFee.vue?vue&type=style&index=0&id=52ac3821&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ac3821",
  null
  
)

export default component.exports